import { Flex } from "@otrium/core";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/css";

const animation = keyframes`
    0% {    
      background-color: rgba(0, 0, 0, 0);
    }
    100% {
      background-color: rgba(0, 0, 0, 0.5);
    }
`;

const Wrapper = styled(Flex)<{
  mobileTop?: number;
  tabletTop?: number;
  desktopTop?: number;
  isActive?: boolean;
  delay?: number;
}>`
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndex.popup};
  background-color: ${({ isActive }) =>
    isActive ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0)"};

  ${({ mobileTop, desktopTop, theme }) =>
    mobileTop &&
    `;
  top: ${mobileTop}px;
  height: calc(100% - ${mobileTop}px);
  @media (min-width: ${theme.breakpoints[3]}) {
    top: ${desktopTop}px;
    height: calc(100% - ${desktopTop}px);
  }
  `}

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    ${({ tabletTop }) =>
      tabletTop &&
      `
      top: ${tabletTop}px;
      height: calc(100% - ${tabletTop}px);
    `}
    transition: background-color ${({ delay }) => delay || 0}ms ease-in-out;
    animation: ${animation} ${({ delay }) => delay || 0}ms ease-in-out;
  }
`;

export { Wrapper };
